<template>
  <v-app>
    <v-btn
      icon
      class="theme-toggle"
      :aria-label="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
      :title="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
      @click="toggleTheme"
    >
      <v-icon>{{ isDark ? "mdi-weather-sunny" : "mdi-weather-night" }}</v-icon>
    </v-btn>
    <v-container class="brand-wrap">
      <div class="brand-row">
        <h1 class="brand-title mb-0"><span class="brand-title__accent">Bright</span><span>Studio</span></h1>
        <div class="brand-signature">
          <span class="brand-signature__by">by</span>
          <img :src="require('@/assets/DEFOR.png')" class="brand-signature__logo" alt="DEFOR" />
        </div>
      </div>
    </v-container>
    <v-main class="pt-0">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  computed: {
    isDark() {
      return this.$vuetify.theme.dark;
    },
  },

  methods: {
    toggleTheme() {
      const next = !this.$vuetify.theme.dark;
      this.$vuetify.theme.dark = next;
      try {
        window.localStorage.setItem("defor-theme", next ? "dark" : "light");
      } catch (_) {
        // localStorage unavailable — preference will not persist across reload
      }
    },
  },
};
</script>

<style>
:root {
  --accent: #e8b25f;
  --accent-soft: rgba(232, 178, 95, 0.18);
  --accent-line: rgba(232, 178, 95, 0.55);
  --grid-line-dark: rgba(255, 255, 255, 0.035);
  --grid-line-light: rgba(15, 18, 22, 0.055);
}

.theme--dark.v-application {
  background-color: #0e1116 !important;
  background-image: linear-gradient(var(--grid-line-dark) 1px, transparent 1px),
    linear-gradient(90deg, var(--grid-line-dark) 1px, transparent 1px);
  background-size: 48px 48px, 48px 48px;
  background-position: -1px -1px, -1px -1px;
}

.theme--light.v-application {
  background-color: #f5f3ee !important;
  background-image: linear-gradient(var(--grid-line-light) 1px, transparent 1px),
    linear-gradient(90deg, var(--grid-line-light) 1px, transparent 1px);
  background-size: 48px 48px, 48px 48px;
}

.brand-wrap {
  padding-top: 2.5rem;
  padding-bottom: 0.5rem;
}

.brand-title {
  font-family: "JetBrains Mono", ui-monospace, monospace !important;
  font-weight: 600;
  font-size: 3.2rem;
  line-height: 1;
  letter-spacing: -0.02em;
  margin: 0;
  text-align: left;
}

.brand-title__accent {
  color: var(--accent);
}

.brand-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.brand-signature {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
}

.brand-signature__by {
  font-family: "JetBrains Mono", ui-monospace, monospace;
  font-size: 0.65rem;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  opacity: 0.55;
  font-weight: 500;
}

.brand-signature__logo {
  height: 22px;
  width: auto;
  display: block;
  opacity: 0.95;
}

.v-card__subtitle {
  font-family: "JetBrains Mono", ui-monospace, monospace !important;
  font-size: 0.7rem !important;
  letter-spacing: 0.18em !important;
  text-transform: uppercase !important;
  opacity: 0.72;
  font-weight: 500 !important;
  position: relative;
  padding-left: 24px !important;
}

.v-card__subtitle::before {
  content: "";
  position: absolute;
  left: 12px;
  top: 50%;
  width: 6px;
  height: 6px;
  background: var(--accent);
  border-radius: 50%;
  transform: translateY(-50%);
  box-shadow: 0 0 8px var(--accent-soft);
}

.v-card.v-sheet--outlined {
  border-color: rgba(255, 255, 255, 0.07) !important;
}

.theme--light .v-card.v-sheet--outlined {
  border-color: rgba(15, 18, 22, 0.09) !important;
}
</style>

<style scoped>
.theme-toggle {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
}
</style>
